import {Box, Typography} from "@mui/material";
import type {ContentWordCount} from "../../../../../sdo/ContentWordCount.ts";

interface ContentWordCardProps {
    word: ContentWordCount;
    selected: boolean;
    onClick: (word: ContentWordCount) => void;
}

function ContentWordCard({word, selected, onClick}: ContentWordCardProps) {
    return (
        <Box
            onClick={() => onClick(word)}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px 10px",
                borderRadius: "8px",
                border: selected ? "1px solid #38ff82" : "0.5px solid #3F464F",
                background: selected
                    ? "linear-gradient(155deg, rgba(0, 143, 130, 0.25) 0%, rgba(0, 38, 53, 0.30) 50%, rgba(0, 0, 0, 0.30) 100%)"
                    : "linear-gradient(155deg, rgba(0, 71, 106, 0.30) 0%, rgba(0, 38, 53, 0.30) 25%, rgba(0, 0, 0, 0.30) 90%, rgba(0, 0, 0, 0.40) 100%)",
                cursor: "pointer",
                transition: "border-color 0.15s, background 0.15s",
                "&:hover": {
                    borderColor: selected ? "#38ff82" : "#7093a0",
                },
            }}
        >
            <Typography sx={{
                color: selected ? "#02cfee" : "#f2f5fa",
                fontSize: "0.80rem",
                fontWeight: 700,
                transition: "color 0.15s",
            }}>
                {word.word}
            </Typography>
            <Typography sx={{
                color: "#38ff82",
                fontSize: "0.75rem",
                fontWeight: 700,
            }}>
                {word.count}
            </Typography>
        </Box>
    );
}

export default ContentWordCard;
